import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryStateContext } from '../../contexts';
import { useRemoveCondition, useResetConditionErrors } from '../../hooks/condition';

export const RemoveButton = () => {
  const { RemoveConditionButton } = useVisualComponentsContext();
  const removeCondition = useRemoveCondition();
  const resetConditionErrors = useResetConditionErrors();
  const { isReadOnly = false } = useQueryStateContext();

  return (
    <RemoveConditionButton
      isDisabled={isReadOnly}
      onClick={() => {
        removeCondition();
        resetConditionErrors();
      }}
    />
  );
};
